import styled from "styled-components";

export const NotFound = styled.td`
    padding: 2rem;
    text-align: center;
    width: 100%;
`;
